import { getAnalyticsConsent } from './analytics-consent-storage';

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
    googlefc?: {
      callbackQueue: unknown[];
      showRevocationMessage?: unknown;
    };
  }
}

export function applyGoogleConsent(granted: boolean): void {
  const state = granted ? 'granted' : 'denied';
  const gtag = window.gtag;
  if (typeof gtag !== 'function') return;
  gtag('consent', 'update', {
    ad_storage: state,
    ad_user_data: state,
    ad_personalization: state,
    analytics_storage: state,
  });
}

export function applyStoredGoogleConsent(): void {
  applyGoogleConsent(getAnalyticsConsent() === 'granted');
}

export function ensureGoogleFcQueue(): void {
  window.googlefc = window.googlefc || { callbackQueue: [] };
  window.googlefc.callbackQueue = window.googlefc.callbackQueue || [];
}

/** Resolves when Google's CMP reports consent data, or when `timeoutMs` elapses. */
export function waitForGoogleAdConsent(timeoutMs: number): Promise<void> {
  applyStoredGoogleConsent();
  ensureGoogleFcQueue();
  return new Promise((resolve) => {
    let settled = false;
    const done = () => {
      if (settled) return;
      settled = true;
      resolve();
    };
    window.googlefc?.callbackQueue.push({ CONSENT_DATA_READY: done });
    window.googlefc?.callbackQueue.push({ CONSENT_API_READY: done });
    window.setTimeout(done, timeoutMs);
  });
}